<template>
    <div v-show="visible">
        <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="400px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item prop="flowName" label="流程名称">
                        <el-input v-model="form.flowName" maxlength="80" style="width:195px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="flowType" label="流程类型">
                       <el-select v-model="form.flowType" clearable placeholder="请选择">
                            <el-option
                                v-for="item in flowTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="attendaceGroupId" label="绑定考勤组">
                        <el-select v-model="form.attendaceGroupId" clearable placeholder="请选择">
                            <el-option
                                v-for="item in attendaceGroups"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item   prop="flowSign" label="是否激活">
                        <el-checkbox v-model="form.flowSign"></el-checkbox>
                    </el-form-item>  

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    deptId:"",
                    flowName:"",
                    flowType:"",
                    attendaceGroupId:"",
                    flowSign:true
                },
                rules: {
                    flowName: [
                        { required: true, message: '请输入流程名称', trigger: 'blur' }
                    ],
                    flowType: [
                        { required: true, message: '请选择流程类型', trigger: 'blur' }
                    ],
                    attendaceGroupId: [
                        { required: true, message: '绑定考勤组', trigger: 'blur' }
                    ]
                },
                flowTypes:[{
                    value: 1,
                    label: '请假'
                }, {
                    value: 2,
                    label: '补卡'
                }],
                attendaceGroups:[]
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.getAttendaceGroup();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            //获取考勤组
            getAttendaceGroup(){
                let url  = this.listAttendaceGroupDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                      this.attendaceGroups = res.data; 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.flowDesignAddUrl;
                        let data = {
                            deptId:this.form.deptId,
                            flowName:this.form.flowName,
                            flowType:this.form.flowType,
                            flowSign:this.form.flowSign?1:2,
                            attendaceGroupId:this.form.attendaceGroupId
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/flow/design/Add.vue